import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link2, Check } from 'lucide-react';

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.6c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4zM12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2z" />
  </svg>
);

const FacebookIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M22 12a10 10 0 1 0-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.3v7A10 10 0 0 0 22 12z" />
  </svg>
);

const btnCls = 'inline-flex items-center gap-2 rounded-full border border-terracotta/25 px-4 py-2.5 text-sm font-semibold text-textDark hover:bg-terracotta hover:text-beige hover:border-terracotta transition-colors';

export const ShareBar = ({ url, title }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const encoded = encodeURIComponent(url);
  const wa = `https://wa.me/?text=${encodeURIComponent(`${title}\n${url}`)}`;
  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encoded}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { /* clipboard unavailable */ }
  };

  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="share-bar">
      <span className="text-sm uppercase tracking-[0.18em] text-textDark/50 mr-1">{t('share.label')}</span>
      <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="share-whatsapp" className={btnCls}>
        <WhatsAppIcon className="w-4 h-4" /> WhatsApp
      </a>
      <a href={fb} target="_blank" rel="noopener noreferrer" data-testid="share-facebook" className={btnCls}>
        <FacebookIcon className="w-4 h-4" /> Facebook
      </a>
      <button type="button" onClick={copy} data-testid="share-copy" className={btnCls}>
        {copied ? <Check size={16} /> : <Link2 size={16} />} {copied ? t('share.copied') : t('share.copy')}
      </button>
    </div>
  );
};
